import { PhotoPreview } from 'enums/shared/photoPreview';

export const getPhotoPreview = (img: RemoteFile): PhotoPreview => {
  const h = img.height ?? img.previewHeight ?? 0;
  const w = img.width ?? img.previewWidth ?? 0;
  const aspectRatio = h / w;
  if (aspectRatio > 1.2) {
    return PhotoPreview.Vertical;
  } else if (aspectRatio < 0.8) {
    return PhotoPreview.Horizontal;
  } else {
    return PhotoPreview.Quadrangle;
  }
};

export const getPrivateChannelWidth = (preview: PhotoPreview): number => {
  if (preview === PhotoPreview.Horizontal) {
    return 320;
  } else if (preview === PhotoPreview.Vertical) {
    return 240;
  } else {
    return 270;
  }
};
